import { createStyles, makeStyles } from '@material-ui/core';
import { darkBlue, white } from '@signaturit/react-components-library';

export const useUserFixedNotificationsStyles = makeStyles(() =>
    createStyles({
        embeddedNotificationWrapper: {
            padding: '6px 24px 0',
        },
        linkStyle: {
            color: `${white} !important`,
            textDecoration: 'underline !important',
            fontSize: 14,
        },
        warningLink: {
            color: `${darkBlue} !important`,
            textDecoration: 'underline !important',
        },
        bulletRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: 20,
        },
        bullet: {
            color: darkBlue,
            fontSize: 34,
        },
        downgradeLoseFeatures: {
            display: 'flex',
            flexDirection: 'column',
        },
        downgradeLink: {
            width: 'fit-content',
            color: `${darkBlue} !important`,
            borderBottom: ` 1px solid ${darkBlue}`,
        },
    })
);
